export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_200.707d0f85.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};